
  import { Component, Prop, Vue } from 'vue-property-decorator';

  @Component({
    inheritAttrs: false,
  })
  export default class MaterialChartCard extends Vue {
    @Prop({ type: Object, default: () => ({}) }) private readonly data!: object
    @Prop({ type: Array, default: () => ([]) }) private readonly eventHandlers!: Array<(x: any) => void>
    @Prop({ type: Object, default: () => ({}) }) private readonly options!: object
    @Prop({ type: String, default: undefined }) private readonly ratio!: string
    @Prop({ type: Array, default: () => ([]) }) private readonly responsiveOptions!: any[]
    @Prop({
      type: String,
      required: true,
      validator: (v: string) => ['Bar', 'Line', 'Pie'].includes(v),
    }) private type!: string
  }
